import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemCategory\ReorderItemsInCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/ReorderItemsInCategoryController.php
* @route '/api/item-category/{itemCategory}/reorder-items'
*/
const ReorderItemsInCategoryController = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderItemsInCategoryController.url(args, options),
    method: 'put',
})

ReorderItemsInCategoryController.definition = {
    methods: ["put"],
    url: '/api/item-category/{itemCategory}/reorder-items',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ItemCategory\ReorderItemsInCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/ReorderItemsInCategoryController.php
* @route '/api/item-category/{itemCategory}/reorder-items'
*/
ReorderItemsInCategoryController.url = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { itemCategory: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { itemCategory: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            itemCategory: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        itemCategory: typeof args.itemCategory === 'object'
        ? args.itemCategory.id
        : args.itemCategory,
    }

    return ReorderItemsInCategoryController.definition.url
            .replace('{itemCategory}', parsedArgs.itemCategory.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemCategory\ReorderItemsInCategoryController::__invoke
* @see app/Http/Controllers/ItemCategory/ReorderItemsInCategoryController.php
* @route '/api/item-category/{itemCategory}/reorder-items'
*/
ReorderItemsInCategoryController.put = (args: { itemCategory: string | number | { id: string | number } } | [itemCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderItemsInCategoryController.url(args, options),
    method: 'put',
})

export default ReorderItemsInCategoryController